import { render } from "./UserMe.vue?vue&type=template&id=7da05423&scoped=true"
import script from "./UserMe.vue?vue&type=script&lang=js"
export * from "./UserMe.vue?vue&type=script&lang=js"

import "./UserMe.vue?vue&type=style&index=0&id=7da05423&scoped=true&lang=css"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da05423"]])

export default __exports__